import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-705cb70e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { useVModel } from '@vueuse/core';
import CropImageUpload from '@/components/CropImageUpload';
import { addTenant } from '@/api/tenant';
export default {
  __name: 'CounselorMenu',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['data', 'update:modelValue', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const menuList = ['集团介绍', '医院介绍', '医生介绍', '接诊流程', '收费项目', '案例对比'];
    const isVisible = useVModel(props);
    const emits = __emit;
    watch(() => props.model, value => {
      if (value) {
        form.value = {
          ...value
        };
      }
    });
    const ruleFormRef = ref(null);
    const form = ref({});
    const submitHandler = async () => {
      try {
        await ruleFormRef.value.validate();
        await addTenant(form.value);
        emits('date');
        ElMessage({
          message: '修改成功',
          type: 'success'
        });
        isVisible.value = false;
        emits('data');
        resetForm();
      } catch (error) {
        console.log(error);
      }
    };
    const resetForm = () => {
      var _ruleFormRef$value;
      (_ruleFormRef$value = ruleFormRef.value) === null || _ruleFormRef$value === void 0 || _ruleFormRef$value.resetFields();
      form.value = {};
      emits('clearModel');
    };
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: "咨询师端菜单封面编辑",
        "destroy-on-close": "",
        width: "60%",
        class: "dialog-class",
        onClosed: resetForm,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.dialogTenantVisible = false)
        }, {
          default: _withCtx(() => [_createTextVNode(" 取消 ")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          "status-icon": "",
          model: form.value,
          ref_key: "ruleFormRef",
          ref: ruleFormRef
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (item, index) => {
            return _createVNode(_component_el_form_item, {
              label: menuList[index] + '菜单封面',
              prop: `picUrl${index + 3}`,
              key: index
            }, {
              default: _withCtx(() => {
                var _props$model;
                return [_createVNode(_unref(CropImageUpload), {
                  modelValue: form.value[`picUrl${index + 3}`],
                  "onUpdate:modelValue": $event => form.value[`picUrl${index + 3}`] = $event,
                  id: (_props$model = __props.model) === null || _props$model === void 0 ? void 0 : _props$model.id,
                  width: 524,
                  height: 310
                }, null, 8, ["modelValue", "onUpdate:modelValue", "id"])];
              }),
              _: 2
            }, 1032, ["label", "prop"]);
          }), 64))]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};